export default {
  name: 'moral-noanswer-list',
  created () {
    this.search()
  },
  data () {
    return {
      callbackflg: false,
      deadlineKey: null
    }
  },
  computed: {
    moralNoanswers () {
      return this.$store.getters.moralNoanswers
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    }
  },
  methods: {
    search: function() {
      var self = this
      var data = {
        'user_id': window.localStorage.getItem('user_id')
      }
      var callback
      callback = function() {
        self.callbackflg = true
        self.deadlineKey = self.$store.getters.moralNoanswers[0].attributes['moral-end-date-format']
      }
      this.$store.dispatch('MORAL_NOANSWER_LIST',  {data: data, callback: callback})
    },
    keybreak: function(index) {
      if (this.moralNoanswers[index].attributes['moral-end-date-format'] == this.deadlinekey) {
        return false
      } else {
        this.deadlinekey = this.moralNoanswers[index].attributes['moral-end-date-format']
        return true
      }
    },
    first: function(index) {
      if (index == 0) {
        return 'border-radius: 5px 5px 0px 0px;'
      } else {
        return ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/moral-noanswer-list.js